import SocketUtils from "./socketUtils";
import {SquadflixDevice} from "../../../../hooks/useSquadflixTv";

export type SquadflixVideo = {
    videoUrl: string;
    streamingVideoUrl: string;
    streaming: boolean;
    subtitles: any[];
    audios: any[]; item: any;
    runtime: number;
    downloadInfo: any;
    title: string;
}

export class SquadflixSocketEmitEvents {
    static sendViewingItem = (device: SquadflixDevice, item?: any, type?: 'movie' | 'serie' | 'live') => {
        SocketUtils.emit("viewing_item", {device, item, type});
    }

    static sendStopViewingItem = (device: SquadflixDevice) => {
        this.sendViewingItem(device, undefined, undefined);
    }

    static sendPlayingVideo = (device: SquadflixDevice, video: SquadflixVideo) => {
        SocketUtils.emit("play_video_squadflix", {device, video});
    }
}
